/* mobile menu */
$('.header__hamburger').click(function(){
    $(this).toggleClass('header__hamburger--open');
    $('html, body').toggleClass('blocked');
    $('html, body').toggleClass('mobile-visible');
    $(".header__nav").toggleClass('header__nav--visible');
});